import { CONTACT } from "@/lib/site";

const FloatingWhatsApp = () => (
  <a
    href={CONTACT.whatsappUrl}
    target="_blank"
    rel="noopener noreferrer"
    data-testid="whatsapp-floating-btn"
    aria-label="Escríbeme por WhatsApp"
    className="fixed bottom-6 right-6 md:bottom-8 md:right-8 z-50 group"
  >
    <span className="absolute inset-0 rounded-full bg-[#25D366]/40 animate-ping" />
    <span className="relative flex items-center justify-center w-14 h-14 md:w-16 md:h-16 rounded-full bg-[#25D366] text-white shadow-2xl shadow-[#25D366]/30 transition-transform group-hover:-translate-y-1">
      <svg viewBox="0 0 32 32" fill="currentColor" className="w-7 h-7 md:w-8 md:h-8" aria-hidden="true">
        <path d="M19.11 17.205c-.372 0-1.088 1.39-1.518 1.39a.63.63 0 0 1-.315-.1c-.802-.402-1.504-.817-2.163-1.447-.545-.516-1.146-1.29-1.46-1.963a.426.426 0 0 1-.073-.215c0-.33.99-.945.99-1.49 0-.143-.73-2.09-.832-2.335-.143-.372-.214-.487-.6-.487-.187 0-.36-.043-.53-.043-.302 0-.53.115-.746.315-.688.645-1.032 1.318-1.04 2.262v.114c-.015.99.472 1.977 1.137 2.78 1.345 1.65 2.595 2.515 4.448 3.323.546.244.96.43 1.404.498.215.044.456.07.683.07.804 0 1.665-.32 1.948-1.066.143-.388.215-.79.215-1.19 0-.058-.014-.115-.014-.158-.07-.27-.143-.43-.516-.6Zm-3.176 9.61h-.026A12.13 12.13 0 0 1 9.65 25.13l-.43-.258-4.546 1.187 1.213-4.43-.286-.456a11.95 11.95 0 0 1-1.83-6.398C3.785 9.115 9.32 3.6 16.05 3.6c3.265 0 6.33 1.275 8.638 3.585A12.16 12.16 0 0 1 28.27 15.8c-.014 6.66-5.55 12.165-12.336 12.165h-.014ZM27.45 4.345A15.94 15.94 0 0 0 16.05.5C7.55.5.612 7.41.612 15.9c-.014 2.73.7 5.385 2.058 7.74L.477 31.5l8.024-2.097a15.97 15.97 0 0 0 7.534 1.92h.013c8.5-.014 15.439-6.925 15.439-15.42 0-4.115-1.6-7.987-4.518-10.91l-.014-.013Z" />
      </svg>
    </span>
  </a>
);

export default FloatingWhatsApp;
